import React from 'react';
import Store from 'store/store';
import TableComponents from 'components/Table';
import ChargesTableRow from './ChargesTableRow';
import { makeStyles } from '@material-ui/core';

const { connect, selectors } = Store;

const useStyles = makeStyles({
  tableHeading: {
    fontSize: '1rem',
    fontWeight: 600,
    padding: '1rem'
  }
});

interface ChargesTableProps {
  existingPolicyCharges: any;
  recommendedPoliciesCharges: any;
  existingOnly?: boolean;
}

const ChargesTable = ({
  existingPolicyCharges,
  recommendedPoliciesCharges,
  existingOnly = false
}: ChargesTableProps) => {
  const classes = useStyles();
  return (
    <>
      <TableComponents.Table>
        <TableComponents.TableHead
          cells={[
            '',
            'Investment fund charges',
            'Transaction costs',
            'Provider/platform charges',
            'Portfolio management charge',
            'Other charges',
            'Total effective charge (excluding ongoing adviser charges)',
            'Ongoing adviser charges',
            'Total effective charge (including ongoing adviser charges)'
          ]}
        />
        <TableComponents.TableBody>
          {!existingOnly && existingPolicyCharges.length > 0 && (
            <div className={classes.tableHeading}>Existing portfolio</div>
          )}
          <ChargesTableRow charges={existingPolicyCharges} type="existing" />
          {!existingOnly && recommendedPoliciesCharges.length > 0 && (
            <>
              <div className={classes.tableHeading}>Recommended portfolio</div>
              <ChargesTableRow
                charges={recommendedPoliciesCharges}
                type="recommended"
              />
            </>
          )}
        </TableComponents.TableBody>
      </TableComponents.Table>
    </>
  );
};

export default connect((state: any) => ({
  existingPolicyCharges: selectors.caseSelectors.existingPoliciesCharges(state),
  recommendedPoliciesCharges:
    selectors.caseSelectors.recommendedPoliciesCharges(state)
}))(ChargesTable);
